import styled, { css } from 'styled-components';

export const HeaderContainer = styled.div<{
  $canCollapse: boolean;
  $smallTopSpacing: boolean;
}>`
  margin: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(6)} ${theme.spacing(1)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ $canCollapse, theme }) =>
    $canCollapse &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing(1)};
    `};
`;

export const IconButtonContainer = styled.span`
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;
